<script>export let id = "proxima-iframe";
export let url = "";
export let title = "";
export let width;
export let height;
export let iframeOnLoadHandler;
</script>

<iframe
    {id}
    class="prx-iframe"
    src={url}
    {width}
    {height}
    {title}
    on:load={iframeOnLoadHandler}
/>

<style>.prx-iframe {
  border: none;
  display: block;
}</style>
